(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["syk-detail-slider"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('syk-x5-detail-slider')) {
  customElements.define('syk-x5-detail-slider', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.track = this.querySelector('[data-syk-detail-track]');
      this.prev = this.querySelector('[data-syk-detail-prev]');
      this.next = this.querySelector('[data-syk-detail-next]');
      if (!this.track || !this.prev || !this.next) {
        this.initTimer = window.setTimeout(() => { if (this.isConnected) this.connectedCallback(); }, 0);
        return;
      }
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.updateButtons = () => {
        const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        this.prev.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= maximum - 2;
      };
      this.prev.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', this.updateButtons, { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? -1 : 1);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.track.scrollTo({ left: event.key === 'Home' ? 0 : this.track.scrollWidth, behavior: this.behavior() });
        }
      }, options);
      this.track.addEventListener('dragstart', event => event.preventDefault(), options);
      this.track.addEventListener('pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;
        this.drag = { id: event.pointerId, x: event.clientX, scroll: this.track.scrollLeft, moved: false };
        this.track.setPointerCapture(event.pointerId);
      }, options);
      this.track.addEventListener('pointermove', event => {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        const delta = event.clientX - this.drag.x;
        if (!this.drag.moved && Math.abs(delta) < 5) return;
        this.drag.moved = true;
        this.track.classList.add('is-dragging');
        event.preventDefault();
        this.track.scrollLeft = this.drag.scroll - delta;
      }, options);
      const finishDrag = event => {
        if (!this.drag || event.pointerId !== this.drag.id) return;
        const moved = this.drag.moved;
        this.drag = null;
        this.track.classList.remove('is-dragging');
        if (moved) this.snapToNearest();
      };
      this.track.addEventListener('pointerup', finishDrag, options);
      this.track.addEventListener('pointercancel', finishDrag, options);
      this.track.addEventListener('lostpointercapture', finishDrag, options);
      document.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.syk-detail-card');
        if (card && this.contains(card)) this.track.scrollTo({ left: card.offsetLeft, behavior: 'auto' });
      }, options);
      this.observer = new ResizeObserver(this.updateButtons);
      this.observer.observe(this.track);
      this.updateButtons();
    }
    disconnectedCallback() {
      window.clearTimeout(this.initTimer);
      this.controller?.abort();
      this.observer?.disconnect();
      this.track?.classList.remove('is-dragging');
      this.controller = null;
      this.drag = null;
    }
    behavior() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }
    move(direction) {
      const card = this.track.querySelector('.syk-detail-card');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.track.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: this.behavior() });
    }
    snapToNearest() {
      const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const positions = Array.from(this.track.querySelectorAll('.syk-detail-card'), card => Math.min(card.offsetLeft, maximum));
      if (!positions.length) return;
      const nearest = positions.reduce((best, value) => Math.abs(value - this.track.scrollLeft) < Math.abs(best - this.track.scrollLeft) ? value : best);
      this.track.scrollTo({ left: nearest, behavior: this.behavior() });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["syk-review-product-grid"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('syk-brush-product-carousel')) {
  customElements.define('syk-brush-product-carousel', class extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => {
        this.initFrame = null;
        this.initialize();
      });
    }
    initialize() {
      if (this.controller) return;
      this.track = this.querySelector('[data-syk-db-track]');
      if (!this.track) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.navigation = this.querySelector('[data-syk-db-navigation]');
      this.progress = this.querySelector('[data-syk-db-progress]');
      this.previous = this.querySelector('[data-syk-db-prev]');
      this.next = this.querySelector('[data-syk-db-next]');
      this.track.querySelectorAll('.is-x7-l').forEach(card => this.track.append(card));
      this.cards = [...this.track.querySelectorAll('.syk-db-card')];
      this.points = [];
      this.destination = null;
      this.suppressClick = false;
      this.track.addEventListener('scroll', () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => { this.destination = null; this.update(); }, 160);
      }, { passive: true, signal });
      this.previous?.addEventListener('click', () => this.step(-1), { signal });
      this.next?.addEventListener('click', () => this.step(1), { signal });
      this.progress?.addEventListener('input', () => {
        this.destination = null;
        this.track.scrollTo({ left: Number(this.progress.value) / 1000 * this.maximum, behavior: 'instant' });
        this.update();
      }, { signal });
      this.progress?.addEventListener('change', () => this.move(this.nearestIndex(this.track.scrollLeft)), { signal });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') this.move(0);
        else if (event.key === 'End') this.move(this.points.length - 1);
        else this.step(event.key === 'ArrowLeft' ? -1 : 1);
      }, { signal });
      this.track.addEventListener('wheel', () => { this.destination = null; }, { passive: true, signal });
      this.track.addEventListener('pointerdown', event => {
        this.destination = null;
        this.suppressClick = false;
        if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button, input')) return;
        this.drag = { x: event.clientX, left: this.track.scrollLeft, id: event.pointerId, moved: false };
      }, { signal });
      this.track.addEventListener('pointermove', event => {
        if (!this.drag || this.drag.id !== event.pointerId) return;
        const distance = event.clientX - this.drag.x;
        if (Math.abs(distance) > 6 && !this.drag.moved) {
          this.drag.moved = true;
          this.track.classList.add('is-dragging');
          this.track.setPointerCapture(event.pointerId);
        }
        if (!this.drag.moved) return;
        event.preventDefault();
        this.track.scrollLeft = this.drag.left - distance;
      }, { signal });
      const finishDrag = () => {
        if (!this.drag) return;
        const moved = this.drag.moved;
        if (this.track.hasPointerCapture(this.drag.id)) this.track.releasePointerCapture(this.drag.id);
        this.drag = null;
        this.track.classList.remove('is-dragging');
        if (moved) { this.suppressClick = true; this.move(this.nearestIndex(this.track.scrollLeft)); }
      };
      window.addEventListener('pointerup', finishDrag, { signal });
      this.track.addEventListener('pointercancel', finishDrag, { signal });
      this.track.addEventListener('dragstart', event => event.preventDefault(), { signal });
      this.track.addEventListener('click', event => {
        if (!this.suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        this.suppressClick = false;
      }, { capture: true, signal });
      this.querySelectorAll('.syk-db-photo-toggle').forEach(button => {
        button.addEventListener('click', () => {
          const shell = button.closest('.syk-db-media-shell');
          const active = shell.classList.toggle('syk-db-show-rider');
          button.setAttribute('aria-pressed', String(active));
        }, { signal });
      });
      
      this.querySelectorAll('.syk-db-media-shell').forEach(shell => {
        let pressTimer = 0;
        let peeked = false;
        let swallowUntil = 0;
        shell.addEventListener('pointerdown', event => {
          if (event.pointerType === 'mouse') return;
          if (event.target.closest('.syk-db-photo-toggle')) return;
          window.clearTimeout(pressTimer);
          pressTimer = window.setTimeout(() => {
            peeked = true;
            shell.classList.add('syk-db-show-rider');
          }, 180);
        }, { signal });
        const endPress = () => {
          window.clearTimeout(pressTimer);
          pressTimer = 0;
          if (!peeked) return;
          peeked = false;
          swallowUntil = Date.now() + 600;
          window.setTimeout(() => shell.classList.remove('syk-db-show-rider'), 380);
        };
        shell.addEventListener('pointerup', endPress, { signal });
        shell.addEventListener('pointercancel', endPress, { signal });
        shell.addEventListener('pointerleave', endPress, { signal });
        shell.addEventListener('click', event => {
          if (Date.now() > swallowUntil) return;
          swallowUntil = 0;
          event.preventDefault();
          event.stopPropagation();
        }, { capture: true, signal });
      });
      document.addEventListener('shopify:block:select', event => {
        if (!this.contains(event.target)) return;
        const card = event.target.closest('.syk-db-card');
        if (card) this.move(this.nearestIndex(this.cardPosition(card)));
      }, { signal });
      this.resizeObserver = new ResizeObserver(() => this.measure());
      this.resizeObserver.observe(this.track);
      this.cards.forEach(card => this.resizeObserver.observe(card));
      this.measure();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      this.initFrame = null;
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = null;
      clearTimeout(this.settleTimer);
      this.drag = null;
      this.track?.classList.remove('is-dragging');
    }
    cardPosition(card) {
      const origin = this.track.getBoundingClientRect().left + this.track.clientLeft;
      return Math.max(0, Math.min(this.maximum, card.getBoundingClientRect().left - origin + this.track.scrollLeft));
    }
    measure() {
      this.maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.points = [0];
      this.cards.forEach(card => {
        const point = this.cardPosition(card);
        if (point - this.points[this.points.length - 1] > 1) this.points.push(point);
      });
      if (this.maximum - this.points[this.points.length - 1] > 1) this.points.push(this.maximum);
      if (this.navigation) this.navigation.hidden = this.maximum <= 1;
      if (this.progress) {
        const ratio = this.track.clientWidth / Math.max(1, this.track.scrollWidth);
        this.progress.style.setProperty('--syk-thumb-width', Math.max(8, ratio * 100) + '%');
      }
      this.destination = null;
      this.update();
    }
    nearestIndex(position) {
      let nearest = 0;
      this.points.forEach((point, index) => {
        if (Math.abs(point - position) < Math.abs(this.points[nearest] - position)) nearest = index;
      });
      return nearest;
    }
    step(direction) {
      const position = this.destination ?? this.track.scrollLeft;
      this.move(this.nearestIndex(position) + direction);
    }
    move(index) {
      const bounded = Math.max(0, Math.min(index, this.points.length - 1));
      this.destination = this.points[bounded] || 0;
      this.track.scrollTo({ left: this.destination, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      this.update();
    }
    update() {
      const position = Math.max(0, Math.min(this.maximum, this.track.scrollLeft));
      if (this.progress) this.progress.value = this.maximum > 0 ? String(Math.round(position / this.maximum * 1000)) : '0';
      const intended = this.destination ?? position;
      if (this.previous) this.previous.disabled = intended <= 1;
      if (this.next) this.next.disabled = intended >= this.maximum - 1;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["syk_accessory_product"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('syk-accessory-product')) {
  customElements.define('syk-accessory-product', class extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.labels = JSON.parse(this.querySelector('[data-labels]').textContent);
      this.thumbs = [...this.querySelectorAll('[data-image-id]')];
      this.quantity = this.querySelector('input[name="quantity"]');
      this.querySelectorAll('[data-image-id]').forEach(button => button.addEventListener('click', () => this.showImage(button), options));
      this.querySelector('[data-gallery-prev]')?.addEventListener('click', () => this.moveImage(-1), options);
      this.querySelector('[data-gallery-next]')?.addEventListener('click', () => this.moveImage(1), options);
      this.querySelector('[data-qty-minus]').addEventListener('click', () => this.changeQuantity(-1), options);
      this.querySelector('[data-qty-plus]').addEventListener('click', () => this.changeQuantity(1), options);
      this.quantity.addEventListener('change', () => this.normalizeQuantity(), options);
      this.querySelector('[data-variant-select]')?.addEventListener('change', event => this.changeVariant(event.target.value), options);
      this.querySelector('[data-share-button]').addEventListener('click', () => this.share(), options);
      this.querySelector('[data-copy-link]').addEventListener('click', () => this.copyLink(), options);
      this.querySelector('[data-share-url]').addEventListener('click', event => event.target.select(), options);
      this.querySelector('.syk-ap__details')?.addEventListener('toggle', () => {
        const details = this.querySelector('.syk-ap__details');
        if (!details.open && document.activeElement !== details.querySelector('summary')) details.querySelector('summary').focus();
      }, options);
      this.updateGallery();
      this.updateQuantityButtons();
    }
    disconnectedCallback() { this.abortController?.abort(); }
    showImage(button) {
      const image = this.querySelector('.syk-ap__main-image');
      if (!image) return;
      image.src = button.dataset.imageSrc;
      image.removeAttribute('srcset');
      image.alt = button.dataset.imageAlt;
      this.thumbs.forEach(item => {
        const active = item === button;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-current', String(active));
      });
      const scroller = this.querySelector('.syk-ap__thumbs');
      if (scroller) scroller.scrollLeft = Math.max(0, button.offsetLeft - scroller.offsetLeft - (scroller.clientWidth - button.clientWidth) / 2);
      this.updateGallery();
    }
    moveImage(direction) {
      const index = Math.max(0, this.thumbs.findIndex(button => button.classList.contains('is-active')));
      const next = this.thumbs[index + direction];
      if (next) this.showImage(next);
    }
    updateGallery() {
      if (!this.thumbs.length) return;
      const index = Math.max(0, this.thumbs.findIndex(button => button.classList.contains('is-active')));
      this.querySelector('[data-gallery-prev]').disabled = index === 0;
      this.querySelector('[data-gallery-next]').disabled = index === this.thumbs.length - 1;
    }
    normalizeQuantity() {
      const min = Number(this.quantity.min) || 1;
      const step = Number(this.quantity.step) || 1;
      const max = this.quantity.max ? Number(this.quantity.max) : Infinity;
      let value = Number(this.quantity.value);
      if (!Number.isFinite(value)) value = min;
      value = Math.max(min, min + Math.round((value - min) / step) * step);
      if (value > max) value = min + Math.floor((max - min) / step) * step;
      this.quantity.value = String(value);
      this.quantity.dispatchEvent(new Event('input', { bubbles: true }));
      this.updateQuantityButtons();
    }
    changeQuantity(direction) {
      this.quantity.value = String((Number(this.quantity.value) || Number(this.quantity.min) || 1) + direction * (Number(this.quantity.step) || 1));
      this.normalizeQuantity();
      this.quantity.dispatchEvent(new Event('change', { bubbles: true }));
    }
    updateQuantityButtons() {
      const value = Number(this.quantity.value);
      const min = Number(this.quantity.min) || 1;
      const max = this.quantity.max ? Number(this.quantity.max) : Infinity;
      this.querySelector('[data-qty-minus]').disabled = value <= min;
      this.querySelector('[data-qty-plus]').disabled = value >= max;
    }
    changeVariant(id) {
      const variant = this.variants.find(item => String(item.id) === String(id));
      if (!variant) return;
      const form = this.querySelector('form');
      const input = form.querySelector('input[name="id"]');
      input.value = String(variant.id);
      input.disabled = !variant.available;
      input.dispatchEvent(new Event('change', { bubbles: true }));
      this.querySelector('[data-price]').textContent = variant.price;
      const compare = this.querySelector('[data-compare]');
      compare.textContent = variant.compare;
      compare.hidden = !variant.on_sale;
      const add = this.querySelector('[name="add"]');
      add.disabled = !variant.available;
      add.removeAttribute('aria-disabled');
      this.querySelector('[data-add-label]').textContent = variant.available ? this.labels.add : this.labels.sold;
      const productForm = this.querySelector('product-form');
      productForm.error = false;
      productForm.handleErrorMessage?.();
      const payment = this.querySelector('[data-payment]');
      if (payment) payment.hidden = !variant.available;
      this.quantity.min = String(variant.min);
      this.quantity.step = String(variant.step);
      if (variant.max !== null) this.quantity.max = String(variant.max);
      else this.quantity.removeAttribute('max');
      this.normalizeQuantity();
      const thumb = this.thumbs.find(button => String(button.dataset.imageId) === String(variant.image_id));
      if (thumb) this.showImage(thumb);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', String(variant.id));
      window.history.replaceState({}, '', url);
    }
    getShareUrl() {
      const url = new URL(window.location.href);
      const id = this.querySelector('input[name="id"]').value;
      url.search = '';
      url.hash = '';
      if (id) url.searchParams.set('variant', id);
      return url.href;
    }
    async share() {
      const url = this.getShareUrl();
      if (navigator.share) {
        try { await navigator.share({ title: this.dataset.title, url }); return; }
        catch (error) { if (error.name === 'AbortError') return; }
      }
      const panel = this.querySelector('[data-share-panel]');
      panel.hidden = !panel.hidden;
      this.querySelector('[data-share-button]').setAttribute('aria-expanded', String(!panel.hidden));
      const input = this.querySelector('[data-share-url]');
      input.value = url;
      if (!panel.hidden) { input.focus(); input.select(); }
    }
    async copyLink() {
      const input = this.querySelector('[data-share-url]');
      input.value = this.getShareUrl();
      let copied = false;
      try { await navigator.clipboard.writeText(input.value); copied = true; }
      catch (error) { input.focus(); input.select(); copied = document.execCommand('copy'); }
      this.querySelector('[data-share-status]').textContent = copied ? this.labels.copied : this.labels.copy_help;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sykeruns-blog-grid"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('syk-blog-carousel')) {
  customElements.define('syk-blog-carousel', class extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => {
        this.initFrame = null;
        this.initialize();
      });
    }
    initialize() {
      if (this.controller) return;
      this.track = this.querySelector('[data-syk-blog-track]');
      if (!this.track) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.navigation = this.querySelector('[data-syk-blog-navigation]');
      this.progress = this.querySelector('[data-syk-blog-progress]');
      this.previous = this.querySelector('[data-syk-blog-prev]');
      this.next = this.querySelector('[data-syk-blog-next]');
      this.cards = [...this.track.querySelectorAll('.syk-blog-card')];
      this.points = [];
      this.destination = null;
      this.suppressClick = false;
      this.track.addEventListener('scroll', () => {
        if (!this.frame) this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => { this.destination = null; this.update(); }, 160);
      }, { passive: true, signal });
      this.previous?.addEventListener('click', () => this.step(-1), { signal });
      this.next?.addEventListener('click', () => this.step(1), { signal });
      this.progress?.addEventListener('input', () => {
        this.destination = null;
        this.track.scrollTo({ left: Number(this.progress.value) / 1000 * this.maximum, behavior: 'instant' });
        this.update();
      }, { signal });
      this.progress?.addEventListener('change', () => this.move(this.closest(this.track.scrollLeft)), { signal });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track) return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') this.move(0);
        else if (event.key === 'End') this.move(this.points.length - 1);
        else this.step(event.key === 'ArrowLeft' ? -1 : 1);
      }, { signal });
      this.track.addEventListener('wheel', () => { this.destination = null; }, { passive: true, signal });
      this.track.addEventListener('pointerdown', event => {
        this.destination = null;
        this.suppressClick = false;
        if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button, input')) return;
        this.drag = { x: event.clientX, left: this.track.scrollLeft, id: event.pointerId, moved: false };
      }, { signal });
      this.track.addEventListener('pointermove', event => {
        if (!this.drag || this.drag.id !== event.pointerId) return;
        const distance = event.clientX - this.drag.x;
        if (Math.abs(distance) > 6 && !this.drag.moved) {
          this.drag.moved = true;
          this.track.classList.add('is-dragging');
          this.track.setPointerCapture(event.pointerId);
        }
        if (!this.drag.moved) return;
        event.preventDefault();
        this.track.scrollLeft = this.drag.left - distance;
      }, { signal });
      const finishDrag = () => {
        if (!this.drag) return;
        const moved = this.drag.moved;
        if (this.track.hasPointerCapture(this.drag.id)) this.track.releasePointerCapture(this.drag.id);
        this.drag = null;
        this.track.classList.remove('is-dragging');
        if (moved) { this.suppressClick = true; this.move(this.closest(this.track.scrollLeft)); }
      };
      window.addEventListener('pointerup', finishDrag, { signal });
      this.track.addEventListener('pointercancel', finishDrag, { signal });
      this.track.addEventListener('dragstart', event => event.preventDefault(), { signal });
      this.track.addEventListener('click', event => {
        if (!this.suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        this.suppressClick = false;
      }, { capture: true, signal });
      this.resizeObserver = new ResizeObserver(() => this.measure());
      this.resizeObserver.observe(this.track);
      this.cards.forEach(card => this.resizeObserver.observe(card));
      this.measure();
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      this.initFrame = null;
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      this.frame = null;
      clearTimeout(this.settleTimer);
      this.drag = null;
      this.track?.classList.remove('is-dragging');
    }
    cardPosition(card) {
      const origin = this.track.getBoundingClientRect().left + this.track.clientLeft;
      return Math.max(0, Math.min(this.maximum, card.getBoundingClientRect().left - origin + this.track.scrollLeft));
    }
    measure() {
      this.maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.points = [0];
      this.cards.forEach(card => {
        const point = this.cardPosition(card);
        if (point - this.points[this.points.length - 1] > 1) this.points.push(point);
      });
      if (this.maximum - this.points[this.points.length - 1] > 1) this.points.push(this.maximum);
      if (this.navigation) this.navigation.hidden = this.maximum <= 1;
      if (this.progress) {
        const ratio = this.track.clientWidth / Math.max(1, this.track.scrollWidth);
        this.progress.style.setProperty('--syk-thumb-width', Math.max(8, ratio * 100) + '%');
      }
      this.destination = null;
      this.update();
    }
    closest(position) {
      let nearest = 0;
      this.points.forEach((point, index) => {
        if (Math.abs(point - position) < Math.abs(this.points[nearest] - position)) nearest = index;
      });
      return nearest;
    }
    step(direction) {
      const position = this.destination ?? this.track.scrollLeft;
      this.move(this.closest(position) + direction);
    }
    move(index) {
      const bounded = Math.max(0, Math.min(index, this.points.length - 1));
      this.destination = this.points[bounded] || 0;
      this.track.scrollTo({ left: this.destination, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      this.update();
    }
    update() {
      const position = Math.max(0, Math.min(this.maximum, this.track.scrollLeft));
      if (this.progress) this.progress.value = this.maximum > 0 ? String(Math.round(position / this.maximum * 1000)) : '0';
      const intended = this.destination ?? position;
      if (this.previous) this.previous.disabled = intended <= 1;
      if (this.next) this.next.disabled = intended >= this.maximum - 1;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sykeruns-challenge-page-worldcup"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sykeruns-wild-halloween')) {
  customElements.define('sykeruns-wild-halloween', class extends HTMLElement {
    connectedCallback() {
      if (this.abortController) return;
      this.abortController = new AbortController();
      const status = this.querySelector('[data-wh-status]');
      this.querySelectorAll('[data-wh-copy]').forEach(button => {
        button.addEventListener('click', async () => {
          let message = this.dataset.copyFailure;
          try {
            let copied = false;
            if (navigator.clipboard && window.isSecureContext) {
              try {
                await navigator.clipboard.writeText(button.dataset.whCopy);
                copied = true;
              } catch {}
            }
            if (!copied) {
              const field = document.createElement('textarea');
              field.value = button.dataset.whCopy;
              field.style.cssText = 'position:fixed;top:0;left:-9999px';
              this.append(field);
              field.select();
              copied = document.execCommand('copy');
              field.remove();
              button.focus();
              if (!copied) throw new Error('Clipboard unavailable');
            }
            message = this.dataset.copySuccess;
          } catch {}
          if (!status || !this.isConnected) return;
          clearTimeout(this.statusTimer);
          status.textContent = message;
          this.statusTimer = setTimeout(() => { status.textContent = ''; }, 4000);
        }, { signal:this.abortController.signal });
      });
    }
    disconnectedCallback() {
      this.abortController?.abort();
      this.abortController = null;
      clearTimeout(this.statusTimer);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sykeruns-community-video-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  const instances = new WeakMap();
  const rootSelector = '[data-syk-community-reviews]';
  const findRoots = (scope) => {
    const roots = [];
    if (scope.matches && scope.matches(rootSelector)) roots.push(scope);
    if (scope.querySelectorAll) roots.push(...scope.querySelectorAll(rootSelector));
    return roots;
  };

  const initialiseReviews = (scope = document) => {
    findRoots(scope).forEach((root) => {
      if (instances.has(root)) return;
      const track = root.querySelector('[data-syk-review-track]');
      if (!track) return;
      const previousButton = root.querySelector('[data-syk-review-prev]');
      const nextButton = root.querySelector('[data-syk-review-next]');
      const progress = root.querySelector('[data-syk-review-progress]');
      const thumb = root.querySelector('[data-syk-review-progress-thumb]');
      const modal = root.querySelector('[data-syk-video-modal]');
      const player = root.querySelector('[data-syk-video-player]');
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const enabled = root.dataset.sykAutoplay !== 'false';
      const interval = Math.max(2500, (Number(root.dataset.sykAutoplaySpeed) || 4) * 1000);
      const events = new AbortController();
      const listen = (target, name, handler, options = {}) => {
        if (target) target.addEventListener(name, handler, { ...options, signal: events.signal });
      };
      let timer = null;
      let frame = null;
      let destroyed = false;
      let hovered = false;
      let interacting = false;
      let keyboardFocus = false;
      let selectedBlock = false;
      let inViewport = !('IntersectionObserver' in window);
      let resumeAfter = 0;
      let lastFocusedElement = null;
      const maxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);
      const clearTimer = () => {
        if (timer !== null) window.clearTimeout(timer);
        timer = null;
      };
      const canRotate = () => enabled && !destroyed && !motion.matches &&
        !document.hidden && inViewport && !hovered && !interacting && !keyboardFocus &&
        !selectedBlock && (!modal || modal.hidden) && maxScroll() > 2;
      const cardStep = () => {
        const card = track.querySelector('.syk-community-reviews__card');
        if (!card) return track.clientWidth;
        const gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
        return card.getBoundingClientRect().width + gap;
      };
      const scrollTo = (left) => track.scrollTo({
        left: Math.max(0, Math.min(maxScroll(), left)),
        behavior: motion.matches ? 'auto' : 'smooth'
      });
      const schedule = () => {
        clearTimer();
        if (!canRotate()) return;
        timer = window.setTimeout(() => {
          timer = null;
          if (!canRotate()) return;
          const end = maxScroll();
          // At the last card, smoothly return to the real first card; no cloned videos.
          scrollTo(track.scrollLeft >= end - 3 ? 0 : track.scrollLeft + cardStep());
          schedule();
        }, Math.max(interval, resumeAfter - Date.now()));
      };
      const updateControls = () => {
        frame = null;
        if (destroyed) return;
        const end = maxScroll();
        const ratio = end > 0 ? Math.max(0, Math.min(1, track.scrollLeft / end)) : 0;
        if (previousButton) previousButton.disabled = track.scrollLeft <= 2;
        if (nextButton) nextButton.disabled = track.scrollLeft >= end - 2;
        if (progress && thumb) {
          const barWidth = progress.clientWidth;
          const visible = track.scrollWidth > 0 ? track.clientWidth / track.scrollWidth : 1;
          const width = Math.min(barWidth, Math.max(32, barWidth * visible));
          thumb.style.width = `${width}px`;
          thumb.style.left = `${(barWidth - width) * ratio}px`;
        }
      };
      const requestUpdate = () => {
        if (frame === null) frame = window.requestAnimationFrame(updateControls);
      };
      const hold = () => {
        resumeAfter = Date.now() + Math.max(8000, interval);
        schedule();
      };
      const closeModal = (restoreFocus = true) => {
        if (!modal || modal.hidden) return;
        modal.hidden = true;
        if (player) player.replaceChildren();
        if (!document.querySelector('[data-syk-video-modal]:not([hidden])')) {
          document.body.classList.remove('syk-video-modal-open');
        }
        if (restoreFocus && lastFocusedElement && lastFocusedElement.isConnected) lastFocusedElement.focus();
        hold();
      };

      listen(track, 'scroll', () => { requestUpdate(); schedule(); }, { passive: true });
      listen(track, 'wheel', hold, { passive: true });
      listen(root, 'pointerenter', (event) => {
        if (event.pointerType === 'mouse') { hovered = true; schedule(); }
      });
      listen(root, 'pointerleave', (event) => {
        if (event.pointerType === 'mouse') { hovered = false; schedule(); }
      });
      listen(track, 'pointerdown', () => { interacting = true; clearTimer(); }, { passive: true });
      listen(window, 'pointerup', () => { if (interacting) { interacting = false; hold(); } }, { passive: true });
      listen(window, 'pointercancel', () => { if (interacting) { interacting = false; hold(); } }, { passive: true });
      // Native overflow + scroll snapping handles touch swipes; no preventDefault or click interception.
      listen(root, 'focusin', () => {
        keyboardFocus = !!(document.activeElement && document.activeElement.matches(':focus-visible'));
        schedule();
      });
      listen(root, 'focusout', (event) => {
        if (!root.contains(event.relatedTarget)) { keyboardFocus = false; schedule(); }
      });
      listen(track, 'keydown', (event) => {
        if (event.target !== track) return;
        let target;
        if (event.key === 'ArrowRight') target = track.scrollLeft + cardStep();
        else if (event.key === 'ArrowLeft') target = track.scrollLeft - cardStep();
        else if (event.key === 'Home') target = 0;
        else if (event.key === 'End') target = maxScroll();
        else return;
        event.preventDefault();
        scrollTo(target);
        hold();
      });
      listen(previousButton, 'click', () => { scrollTo(track.scrollLeft - cardStep()); hold(); });
      listen(nextButton, 'click', () => { scrollTo(track.scrollLeft + cardStep()); hold(); });
      listen(document, 'visibilitychange', schedule);
      listen(motion, 'change', () => { updateControls(); schedule(); });

      root.querySelectorAll('[data-syk-video-id]').forEach((button) => {
        listen(button, 'click', () => {
          const id = button.dataset.sykVideoId;
          if (!id || !modal || !player) return;
          lastFocusedElement = button;
          const iframe = document.createElement('iframe');
          iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?autoplay=1&rel=0`;
          iframe.title = button.dataset.sykVideoTitle || 'YouTube video';
          iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
          iframe.setAttribute('allowfullscreen', '');
          player.replaceChildren(iframe);
          modal.hidden = false;
          document.body.classList.add('syk-video-modal-open');
          clearTimer();
          const close = modal.querySelector('.syk-community-reviews__close');
          if (close) close.focus();
        });
      });
      root.querySelectorAll('[data-syk-video-close]').forEach((button) => listen(button, 'click', () => closeModal()));
      listen(document, 'keydown', (event) => {
        if (event.key === 'Escape' && modal && !modal.hidden) closeModal();
      });
      listen(root, 'shopify:block:select', (event) => {
        selectedBlock = true;
        clearTimer();
        const card = event.target.closest('.syk-community-reviews__card');
        if (card) scrollTo(track.scrollLeft + card.getBoundingClientRect().left - track.getBoundingClientRect().left);
      });
      listen(root, 'shopify:block:deselect', () => { selectedBlock = false; schedule(); });

      let resizeObserver = null;
      let intersectionObserver = null;
      if ('ResizeObserver' in window) {
        resizeObserver = new ResizeObserver(() => { requestUpdate(); schedule(); });
        resizeObserver.observe(track);
        if (progress) resizeObserver.observe(progress);
      } else {
        listen(window, 'resize', () => { requestUpdate(); schedule(); }, { passive: true });
      }
      if ('IntersectionObserver' in window) {
        intersectionObserver = new IntersectionObserver((entries) => {
          inViewport = entries.some((entry) => entry.isIntersecting);
          schedule();
        }, { threshold: 0.05 });
        intersectionObserver.observe(root);
      }
      instances.set(root, () => {
        destroyed = true;
        clearTimer();
        if (frame !== null) window.cancelAnimationFrame(frame);
        events.abort();
        if (resizeObserver) resizeObserver.disconnect();
        if (intersectionObserver) intersectionObserver.disconnect();
        closeModal(false);
        instances.delete(root);
        delete root.dataset.sykReviewsReady;
      });
      root.dataset.sykReviewsReady = 'true';
      updateControls();
      schedule();
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseReviews(), { once: true });
  } else initialiseReviews();
  document.addEventListener('shopify:section:load', (event) => initialiseReviews(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    findRoots(event.target).forEach((root) => { const destroy = instances.get(root); if (destroy) destroy(); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sykeruns-media-voices"] && !Shopify.designMode) return;
  try {
    


  if (!customElements.get('sykeruns-media-voices')) {
    customElements.define('sykeruns-media-voices', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.selectors = Array.from(this.querySelectorAll('[data-select]'));
        this.sourceLinks = Array.from(this.querySelectorAll('[data-source-link]'));
        this.pause = this.querySelector('[data-pause]');
        this.index = 0;
        if (!this.slides.length) return;
        this.userPaused = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.hovered = false;
        this.focused = false;
        this.visible = false;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.selectors.forEach(button => button.addEventListener('click', () => { this.show(Number(button.dataset.select)); this.start(); }, options));
        this.pause?.addEventListener('click', () => { this.userPaused = !this.userPaused; this.updatePause(); this.start(); }, options);
        this.addEventListener('mouseenter', () => { this.hovered = true; this.start(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.start(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.start(); }, options);
        this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.start(); }, options);
        this.querySelector('.syk-media__frame').addEventListener('touchstart', event => { this.touchX = event.touches[0].clientX; this.touchY = event.touches[0].clientY; }, { ...options, passive: true });
        this.querySelector('.syk-media__frame').addEventListener('touchend', event => {
          const dx = event.changedTouches[0].clientX - this.touchX;
          const dy = event.changedTouches[0].clientY - this.touchY;
          if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) { this.preventClickUntil = Date.now() + 350; this.show(this.index + (dx < 0 ? 1 : -1)); this.start(); }
        }, { ...options, passive: true });
        this.addEventListener('click', event => {
          if (Date.now() < (this.preventClickUntil || 0) && event.target.closest('a')) { event.preventDefault(); event.stopPropagation(); }
        }, { ...options, capture: true });
        this.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index >= 0) { this.show(index); this.userPaused = true; this.updatePause(); this.start(); }
        }, options);
        this.querySelector('.syk-media__dots')?.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1));
          this.selectors[this.index]?.focus();
        }, options);
        document.addEventListener('visibilitychange', () => this.start(), options);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.start(); }, { threshold: 0.2 });
        this.observer.observe(this);
        this.updatePause();
        this.measureSlides();
        this.resizeObserver = new ResizeObserver(entries => {
          const width = entries[0].contentRect.width;
          if (width !== this.measuredWidth) { this.measuredWidth = width; this.measureSlides(); }
        });
        this.resizeObserver.observe(this.querySelector('.syk-media__slides'));
        document.fonts?.ready.then(() => { if (this.isConnected) this.measureSlides(); });
      }
      show(index) {
        if (!this.slides.length || !Number.isFinite(index)) return;
        this.index = ((index % this.slides.length) + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
        this.selectors.forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.select) === this.index)));
        this.sourceLinks.forEach(link => { link.dataset.active = String(Number(link.dataset.sourceIndex) === this.index); });
      }
      measureSlides() {
        const container = this.querySelector('.syk-media__slides');
        if (!container || !this.slides.length) return;
        let height = 0;
        this.slides.forEach(slide => {
          const hidden = slide.hidden;
          const visibility = slide.style.visibility;
          slide.style.visibility = 'hidden';
          slide.hidden = false;
          height = Math.max(height, slide.getBoundingClientRect().height);
          slide.hidden = hidden;
          slide.style.visibility = visibility;
        });
        container.style.minHeight = Math.ceil(height) + 'px';
      }
      updatePause() {
        if (!this.pause) return;
        this.pause.setAttribute('aria-label', this.userPaused ? this.pause.dataset.playLabel : this.pause.dataset.pauseLabel);
        this.pause.firstElementChild.textContent = this.userPaused ? '▷' : 'Ⅱ';
      }
      start() {
        clearInterval(this.timer);
        const running = this.dataset.autoplay === 'true' && this.slides.length > 1 && !this.userPaused && !this.hovered && !this.focused && this.visible && !document.hidden;
        this.querySelector('.syk-media__slides')?.setAttribute('aria-live', running ? 'off' : 'polite');
        if (running) this.timer = setInterval(() => this.show(this.index + 1), Number(this.dataset.interval) || 6000);
      }
      disconnectedCallback() { clearInterval(this.timer); this.abort?.abort(); this.observer?.disconnect(); this.resizeObserver?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
